module.exports = __webpack_public_path__ + "img/wuxian_v1.0.f67bc5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/wuxian_v1.0.png
// module id = YDJe
// module chunks = 0